import { useState } from 'react'
import { Modal, Button, Icon } from 'semantic-ui-react'
import PartnerID from './PartnerID';

const PartnerIDModal = (props) => {
    const [modalOpen, setModalOpen] = useState(false);

    const handleOpen = () => setModalOpen(true);

    const handleClose = () => setModalOpen(false)

    const {  refresh, handleClearRows } = props;

    return (
        <Modal
            trigger={
                <Button color='blue' onClick={handleOpen}>
                    <Icon name='add' />Request Partner ID
                </Button>
            }
            open={modalOpen}
            onClose={handleClose}
            size='large'
            closeOnDimmerClick={false}
        >
            <Modal.Header>Partner ID Details</Modal.Header>
            <PartnerID
                handleClose={handleClose}
                refresh={refresh}
                handleClearRows={handleClearRows}
            />
        </Modal>
    )

}

export default PartnerIDModal